import { useNextRouterContext } from "@faire/deprecated-retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { useSettingLISPShortHoverThreshold } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingLISPHoverThreshold";
import { PrefetchKind } from "next/dist/client/components/router-reducer/router-reducer-types";
import { useCallback, useRef } from "react";

// Limit of how many times we can prefetch per second
const PREFETCH_QPS_LIMIT = 1;

export const useLinkPrefetch = () => {
  const { prefetch: nextPrefetch } = useNextRouterContext();

  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined
  );
  const lastPrefetchTime = useRef<number | undefined>(undefined);
  const PREFETCH_DELAY_MS_SHORT = useSettingLISPShortHoverThreshold();

  const prefetchUrl = useCallback(
    (url?: string) => {
      clearTimeout(timeoutRef.current);
      if (lastPrefetchTime.current) {
        const timeSinceLastPrefetch = Date.now() - lastPrefetchTime.current;
        if (timeSinceLastPrefetch < 1000 / PREFETCH_QPS_LIMIT) {
          return;
        }
      }

      timeoutRef.current = setTimeout(() => {
        if (url) {
          nextPrefetch(url, {
            kind: PrefetchKind.FULL,
          });
          lastPrefetchTime.current = Date.now();
        }
      }, PREFETCH_DELAY_MS_SHORT);
    },
    [PREFETCH_DELAY_MS_SHORT, nextPrefetch]
  );

  const clearLinkPrefetchTimeout = useCallback(() => {
    clearTimeout(timeoutRef.current);
  }, []);

  return {
    prefetchUrl,
    clearLinkPrefetchTimeout,
  };
};
